import { createContext } from "react";

const DimensionContext = createContext(false);

export default DimensionContext;